"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _rowConfig = _interopRequireDefault(require("../core/row-config"));
var _submit = _interopRequireDefault(require("../core/submit"));
var _alert = _interopRequireDefault(require("../core/alert"));
var _IdentityDocumentUpload = _interopRequireWildcard(require("./IdentityDocumentUpload"));
var _TermsOfServiceStatement = _interopRequireDefault(require("./TermsOfServiceStatement"));
var _ClubTreasurerDetails = _interopRequireDefault(require("./ClubTreasurerDetails"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Input = require("../core/input").default;
var _ref = /*#__PURE__*/_react.default.createElement("br", null);
var _ref2 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref3 = /*#__PURE__*/_react.default.createElement(_TermsOfServiceStatement.default, null);
class UpdateClubSetup extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      saving: false,
      error: null,
      identityDoc: null,
      additionalDoc: null,
      club: {
        ...this.props.currentDetails,
        acceptedToS: false
      }
    });
    _defineProperty(this, "_onSubmit", e => {
      e.preventDefault();
      // clear errors
      this.setState({
        error: null
      });
      const {
        identityDoc,
        additionalDoc
      } = this.state;
      if (!(0, _IdentityDocumentUpload.isValidDocumentUploadState)(identityDoc) || !(0, _IdentityDocumentUpload.isValidDocumentUploadState)(additionalDoc)) {
        if (!identityDoc) {
          this.setState({
            error: 'You must provide a scan/photo of your passport or driving licence'
          });
        } else if (!additionalDoc) {
          this.setState({
            error: 'You must provide a second document which includes your address, e.g. a recent utility bill'
          });
        }
        return;
      }
      this.setState({
        saving: true
      });
      Promise.all([identityDoc, additionalDoc].map(doc => doc.fileID)).then(([fileID, additionalFileID]) => {
        return this.props.onSetup({
          fileID,
          additionalFileID,
          ...this.state.club
        });
      }).then(result => {
        if (!result.success) {
          // re-upload the valid images so we can try again without needing to manually re-upload
          for (const doc of [identityDoc, additionalDoc]) {
            doc.refresh();
          }
          this.setState({
            saving: false,
            error: result.error
          });
        } else {
          this.setState({
            saving: false
          });
        }
      }, () => {
        this.setState({
          saving: false
        });
      });
    });
    _defineProperty(this, "_setValue", (value, name) => {
      this.setState({
        club: {
          ...this.state.club,
          [name]: value
        }
      });
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this._onSubmit
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3
      }, {
        sm: 8,
        md: 9
      }]
    }, this.state.error ? /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "danger"
    }, this.state.error) : null, /*#__PURE__*/_react.default.createElement(_ClubTreasurerDetails.default, {
      club: this.state.club,
      onChangeValue: this._setValue
    }), /*#__PURE__*/_react.default.createElement(_IdentityDocumentUpload.default, {
      document: this.state.identityDoc,
      onChange: identityDoc => this.setState({
        identityDoc
      }),
      variant: "identity"
    }), _ref, /*#__PURE__*/_react.default.createElement(_IdentityDocumentUpload.default, {
      document: this.state.additionalDoc,
      onChange: additionalDoc => this.setState({
        additionalDoc
      }),
      variant: "additional"
    }), _ref2, /*#__PURE__*/_react.default.createElement(Input, {
      type: "Checkbox",
      name: "acceptedToS",
      checked: this.state.club.acceptedToS,
      label: _ref3,
      onChange: this._setValue
    }), /*#__PURE__*/_react.default.createElement(_submit.default, {
      loading: this.state.saving
    }, "Setup Club")));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = UpdateClubSetup;